import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import t from "./common/localization";


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EventAlert = () => {
  const [open, setOpen] = React.useState(false);
  const eventData = useSelector((state) => state.eventData.data);
  const deviceData = useSelector(state => state.devices.items);
  const {deviceId} = eventData;
  const eType = eventData.type && eventData.type[0].toUpperCase() + eventData.type.substring(1);
  const deviceItem = deviceData[deviceId];
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const { type = "" } = eventData;
    if (type) {
      const audio = new Audio(`audio/${type.toLowerCase()}.mp3`);
      audio.play();
    }
    setOpen(true);
  }, [eventData.id]);

  if(!deviceId){
      return false;
  }

  return (
    <>
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="warning">
         {deviceItem?.name} {eType && t(`event${eType}`) }
        </Alert>
      </Snackbar>
    </>
  );
};

export default EventAlert;
